var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('titulo',{attrs:{"visualizar":_vm.visualizar,"form":_vm.form},on:{"criar":_vm.novoContato}}),_c('tabela',{attrs:{"form":_vm.form,"visualizar":_vm.visualizar},on:{"excluir":_vm.excluir,"editar":_vm.editar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }